// extracted by mini-css-extract-plugin
module.exports = {"label":"label_label__NtXHf","label_title":"label_label_title__8WtV_"};